export * from './TS_PropRenderer.js';
//# sourceMappingURL=index.js.map